<template>
    <div>
        <b-row v-if="!printView || discounts.length">
            <b-col class="header-menu-text">
                <h5 class="text-secondary">Discounts</h5>
            </b-col>

            <b-col align="right" v-if="!printView">
                <b-dropdown ref="discountDropdown" no-caret size="sm" variant="link" class="menu-btn" toggle-class="text-decoration-none">
                    <template #button-content>
                        <b-button variant="outline-secondary" size="sm">
                            <b-icon-plus></b-icon-plus>
                        </b-button>
                    </template>

                    <discount @addDiscount="addDiscount(null, $event)"></discount>
                </b-dropdown>
            </b-col>
        </b-row>

        <div v-if="!printView">
            <b-row v-if="!hasDiscounts">
                <b-col align="center">
                    <b-list-group>
                        <b-list-group-item variant="light">
                            <small><em>No Discounts</em></small>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>
            </b-row>

            <b-row v-for="(discount, index) in component" v-bind:key="'discount-' + index" class="mb-3">
                <b-col>
                    <b-input-group size="sm" :prepend="discount.type">
                        <!--<b-input :value="discount.type" disabled></b-input>-->
                        <b-input class="py-3"  :value="'$' + discount.amount" disabled></b-input>

                        <b-input-group-append v-if="discount.username">
                            <b-button size="sm" :id="'discountuser-' + index" variant="outline-info">
                                <b-icon-person></b-icon-person>
                            </b-button>

                            <b-tooltip :target="'discountuser-' + index" triggers="hover">
                                {{ discount.username }}
                            </b-tooltip>
                        </b-input-group-append>

                        <b-input-group-append v-if="discount.date">
                            <b-button size="sm" :id="'discountdate-' + index" variant="outline-info">
                                <b-icon-calendar4-event></b-icon-calendar4-event>
                            </b-button>

                            <b-tooltip :target="'discountdate-' + index" triggers="hover">
                                {{ moment(discount.date).format('M/D/YYYY h:mma') }}
                            </b-tooltip>
                        </b-input-group-append>

                        <template #append>
                        <b-dropdown ref="existingDiscountDropdown" no-caret size="sm" variant="outline-info" toggle-class="text-decoration-none">
                            <template #button-content>
                                <b-button class='editButton p-0' variant='outline-info' size="sm">
                                    <b-icon-pencil></b-icon-pencil>
                                </b-button>
                            </template>
                            <discount :initialAmount='discount.amount' :initialType='discount.type' :initialNote='discount.note' :initialDate='discount.date' @removeDiscount="removeDiscount(index, $event)" @addDiscount="addDiscount(index, $event)"></discount>
                        </b-dropdown>
                        </template>

                    </b-input-group>
                    <b-input-group size="sm" v-if="discount.note">
                        <em class="form-control disabled">{{ discount.note }}</em>
                    </b-input-group>
                </b-col>
            </b-row>
        </div>

        <div v-else>
            <div v-for="(discount, index) in component" v-bind:key="index" class="mb-3">
                <b-row>
                    <b-col sm="3">Amount</b-col>
                    <b-col>{{ discount.amount }}</b-col>
                </b-row>

                <b-row>
                    <b-col sm="3">Type</b-col>
                    <b-col>{{ discount.type }}</b-col>
                </b-row>

                <b-row>
                    <b-col sm="3">Note</b-col>
                    <b-col>{{ discount.note }}</b-col>
                </b-row>

                <b-row>
                    <b-col sm="3">Date</b-col>
                    <b-col>{{ moment(discount.date).format('M/D/YYYY h:mma') }}</b-col>
                </b-row>

                <b-row>
                    <b-col sm="3">Username</b-col>
                    <b-col>{{ discount.username }}</b-col>
                </b-row>

            </div>
        </div>
    </div>
</template>

<script>
    import arrayMixin from "../../mixins/array";
    import Discount from "./Discount";

    export default {
        name: "OrderTotals",
        props: [ 'discounts', 'printView' ],
        mixins: [ arrayMixin ],
        components: { Discount },
        created() {
            this.clone(this.discounts);
        },
        methods: {
            addDiscount(index, discount) {
                if (!index && index !== 0) {
                    this.component.push(discount);
                } 
                else {
                    const updatedArray = this.component.map((item, i) => i === index ? discount : item);
                    this.component = updatedArray;
                }
                this.closeDropdown(index);
                this.$emit('updateDiscounts', this.component);
            },
            removeDiscount(index, amount) {

                this.$emit('removeDiscount', amount);
           
                this.component.splice(index, 1);
                this.closeDropdown(index);
               
            },
            closeDropdown(index) {
                if (!index && index !== 0) {this.$refs.discountDropdown.hide();}
                else {this.$refs.existingDiscountDropdown[index].hide();}
            }
        },
        computed: {
            hasDiscounts() {
                return this.component.length > 0
            }
        }
    }
</script>

<style scoped>
    .editButton {
       border: none;
    }
    .input-group-text {
        width: 8rem;
    }

    .list-group-item {
        padding: 0.25rem .5rem;
    }
</style>